//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HTTP from "@/http-common";
import FshiftSignalStructure from "@/components/FshiftSignalStructure";

export default {
    components: {
        FshiftSignalStructure,
    },
    data: function() {
        return {
            fshifts: [],
        };
    },
    created: function() {
        HTTP.get(`frameshifts-signals`)
            .then((response) => {
                // JSON responses are automatically parsed.
                console.log(response.data);
                this.fshifts = response.data.sort(function(a, b) {
                    return a.signal.energy - b.signal.energy;
                });
            })
            .catch((error) => {
                console.warn(error);
            });
        this.$nextTick(() => {
            window.scrollTo(0, 0);
            window.document.getElementById("about").scrollIntoView();
        });
    },
};
